import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { v4 as uuidv4 } from 'uuid';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import BaseIcon from '@material-ui/core/Icon';
import MapIcon from '@material-ui/icons/Map';
import SearchIcon from '@material-ui/icons/Search';
import { AiOutlineLineChart } from 'react-icons/ai';

import { signOut } from '~/store/modules/auth/actions';

import { Container } from './styles';

const routes = [
  {
    icon: <SearchIcon />,
    routename: 'Buscar pacientes',
    pathname: '/search',
    id: uuidv4(),
  },
  {
    icon: <BaseIcon className="icon-infusion" />,
    routename: 'Reg. de medicamento',
    pathname: '/drug',
    id: uuidv4(),
  },
  {
    icon: <AiOutlineLineChart />,
    routename: 'Emitir relatórios',
    pathname: '/reports',
    id: uuidv4(),
  },
  { icon: <MapIcon />, routename: 'Mapas', pathname: '/maps', id: uuidv4() },
];

function MenuDropDown({ anchorEl, setAnchorEl }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const signed = useSelector((state) => state.auth.signed);

  const open = Boolean(anchorEl);
  const popoverId = open ? 'simple-popover' : undefined;

  function handleClick(page) {
    history.push(page);
    setAnchorEl(null);
  }

  useEffect(() => {
    if (!signed) {
      history.push('/');
    }
  }, [signed, history]);

  return (
    <Popover
      id={popoverId}
      open={open}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      marginThreshold={0}
    >
      <Container>
        <List component="nav">
          {routes.map(({ id, pathname, routename, icon }) => {
            return (
              <ListItem key={id} button onClick={() => handleClick(pathname)}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={routename} />
              </ListItem>
            );
          })}

          <ListItem button onClick={() => dispatch(signOut())}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary="Sair da conta" />
          </ListItem>
        </List>
      </Container>
    </Popover>
  );
}

MenuDropDown.propTypes = {
  anchorEl: PropTypes.shape({}),
  setAnchorEl: PropTypes.func.isRequired,
};

MenuDropDown.defaultProps = {
  anchorEl: null,
};

export default MenuDropDown;
